import { useQuery, useQueryClient } from '@tanstack/react-query';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../../store/store';
import { connect } from 'react-redux';
import { ROUTES } from '../../../../routes';
import { useNavigate, useParams } from 'react-router';
import API from '../../../../api';

import OnAfterModalClosed from '../../../../libraries/onAfterModalClosed';
import Builder from '../builder';
import RightSideOfDetail from '../rightSideOfDetail';
import { useLanguage } from '@languages/index';

const SNSYoutubeDetail = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const params = useParams();
  const youtubeId = params.id;

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onAfterModalClosed = new OnAfterModalClosed(props);

  /// state

  /// query
  // fetch brand
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_1,
        });
      }
    },
  });

  // fetch youtube review
  const fetchYoutubeRes = useQuery({
    queryKey: [
      'fetch_youtube_review',
      fetchBrandRes.data?.brand?.id,
      youtubeId,
    ],
    queryFn: async () => {
      try {
        const res = await API.BrandSns.fetchYoutubes({
          brandToken: props.auth.token,
          where: { id: youtubeId },
        });
        return res.data.reviews[0];
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.youtube_detail_text_1,
        });
      }
    },
    enabled: !!fetchBrandRes.data,
  });
  const dirtyfetchYoutube = () =>
    queryClient.removeQueries({
      queryKey: [
        'fetch_youtube_review',
        fetchBrandRes.data?.brand?.id,
        youtubeId,
      ],
    });

  /// sns install check
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
  }

  /// other functions
  const _setYoutubePublishState = async (value: boolean) => {
    const youtube = fetchYoutubeRes.data;
    if (!youtube || !!youtube.isPublished === value) return;

    try {
      props.showModal({
        hideCloseButton: true,
        hideConfirmButton: true,
        text: languageTexts.celeb_detail_text_3,
      });

      const res = await API.BrandSns.updateYoutube(youtube.id, {
        brandToken: props.auth.token,
        isPublished: value,
      });

      props.closeModal();
    } catch (error) {
      onAfterModalClosed.set(() => {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.youtube_detail_text_2,
        });
      });
      props.closeModal();
    }

    dirtyfetchYoutube();
  };

  /// build main
  const build = () => {
    if (!fetchBrandRes.data || !fetchYoutubeRes.data) return null;

    if (!props.brand?.hasExperiencedSnsInstall || !props.brand?.remainSnsPass)
      return null;

    const youtube = fetchYoutubeRes.data;

    return (
      <div className="flex flex-col items-center w-[1025px] mx-auto my-[50px]">
        <div className="flex flex-row w-full">
          {Builder.buildBackwardText((e) => {
            navigate(ROUTES.SNS_INDEX.PATH);
          })}
        </div>

        <div style={{ height: '59px' }} />

        <div className="flex flex-row justify-start w-full">
          {/* left-side */}
          <div className="flex flex-col justify-start w-[400px]">
            {/* youtube */}
            <div
              className="cursor-pointer"
              onClick={() =>
                window.open(
                  `https://www.youtube.com/watch?v=${youtube.videoKey}`,
                )
              }
            >
              <div style={{ position: 'relative' }}>
                <img
                  className={'object-cover w-[400px] h-[225px]'}
                  src={`http://img.youtube.com/vi/${youtube.videoKey}/mqdefault.jpg`}
                />
                <span
                  className="pl-[7px] pr-[3px] py-[4px] font-bold text-[13px] text-[#ffffff] bg-[#0000003C]"
                  style={{ position: 'absolute', bottom: '0px', right: '0px' }}
                >
                  {youtube.duration}
                </span>
              </div>
              <div style={{ height: '10px' }} />
              <span className=" text-[15px]">{youtube.title}</span>
              <div style={{ height: '10px' }} />
              <div className="flex flex-row items-center">
                <div
                  style={{
                    width: '32px',
                    height: '32px',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '50%',
                  }}
                >
                  <img
                    src={youtube.channelThumbnailUrl}
                    style={{
                      display: 'inline',
                      margin: '0 auto',
                      height: '100%',
                      width: 'auto',
                    }}
                  />
                </div>
                <span className="ml-[12px] text-[15px]">
                  {youtube.channelTitle}
                </span>
              </div>
            </div>
          </div>

          {/* right-side */}
          <RightSideOfDetail
            review={youtube}
            onSetPublishState={(v) => _setYoutubePublishState(v)}
            onEditClick={() => {
              navigate(ROUTES.SNS_UPLOAD_YOUTUBE.PATH + `?id=${youtube.id}`);
            }}
            onBsProductUrlChanged={(r) => dirtyfetchYoutube()}
          />
        </div>
      </div>
    );
  };

  return build();
};

export default connect(mapStateToProps, mapDispatchProps)(SNSYoutubeDetail);
